import { BaseComponent } from '../../components/base-component'
import { CartDrawer } from './cart-drawer'
import { FreeShippingBar } from '../../components/free-shipping-bar/free-shipping-bar'
import { $el, $elParent } from 'src/scripts/utils/utils'

const CART_DRAWER_SELECTOR = 'cart-drawer'
const FREE_SHIPPING_BAR_SELECTOR = 'free-shipping-bar'

export class CartDrawerFreeShippingBarBlock extends BaseComponent {
  mountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    cartDrawer?.on('update-nodes', this.handleCartUpdate)
  }

  unmountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    cartDrawer?.off('update-nodes', this.handleCartUpdate)
  }

  handleCartUpdate = (data: any): void => {
    const bar: FreeShippingBar = $el(FREE_SHIPPING_BAR_SELECTOR, this)
    const newBar: FreeShippingBar = $el(FREE_SHIPPING_BAR_SELECTOR, data.node)

    if (!bar || !newBar) {
      return
    }

    const difference =
      newBar.getAttribute('data-free-shipping-difference') || ''
    const differencePercent = +(
      newBar.getAttribute('data-free-shipping-difference-percent') || 0
    )

    bar.updateProgressByDifference(difference, differencePercent)
  }
}
